import io, { Socket } from 'socket.io-client'

import { BASE_URL } from '@/config/http/http'

const SOCKET_EVENTS = {
  CONNECT: 'connect',
  CONNECT_ERROR: 'connect_error',
  NEW_ORDER: 'new_order',
  REJECTED_ORDER: 'order_rejected',
  BUSY_STATUS: 'store_status'
}

type SocketEventHandler = (event: string, data: any) => void

class SocketManager {
  private socket: typeof Socket | null = null
  private eventHandler: SocketEventHandler | null = null
  private connectionKey: string | null = null

  setEventHandler(eventHandler: SocketEventHandler) {
    this.eventHandler = eventHandler
  }

  connect(token: string, namespace: string = `store`) {
    const connectionKey = `${namespace}:${token}`
    // Reconnecting to the same namespace with the same token only produces a
    // disconnect/reconnect cycle during boot.
    if (this.socket && this.connectionKey === connectionKey) return

    this.disconnect()
    this.connectionKey = connectionKey

    this.socket = io(`${BASE_URL}/${namespace}`, {
      transports: ['websocket', 'polling'],
      query: { token }
    })

    if (this.eventHandler) {
      Object.values(SOCKET_EVENTS).forEach(event => {
        this.socket?.on(event, (data: unknown) =>
          this.eventHandler?.(event, data)
        )
      })
    }
  }
  disconnect() {
    this.connectionKey = null
    if (this.socket) {
      this.socket.disconnect()
      this.socket = null
    }
  }
}

const socketSingleton = new SocketManager()

export { SOCKET_EVENTS }
export default socketSingleton
